import React from "react";
import TableUtility from "../../../Common/UtilityCommon/TableUtility";

const PattiEntryUtility = ({ includeYearCode = true }) => {
   const apiUrl = `${process.env.REACT_APP_API}/getall-PattiEntryData`;
   const columns = [
      { label: "Doc No", key: "Doc_No" },
      { label: "Doc Date", key: "Doc_Date" },
      { label: "Credit A/C", key: "Ac_Name_E" },
      { label: "Advances", key: "Advances" },
   ];
   return (
      <TableUtility
         title="Patti Entries"
         apiUrl={apiUrl}
         columns={columns}
         rowKey="Id"
         addUrl="/PattiEntry-api"
         detailUrl="/PattiEntry-api"
         permissionUrl="/PattiEntry-utility"
         includeYearCode={includeYearCode}

      />
   );

};

export default PattiEntryUtility;